var productMeasurementSelector = {
  
    incrementLength: 1,
    initialPrice: parseFloat($('.product__price').text().replace('£', '')),

    init: function() {
      this.quantityControl();
      this.quantityIncrease();
      this.quantityDecrease();
      this.setVariantUpdateEvent();
    },
  
    updateQuantity: function(value, wrapper) {
        var roundedValue = Math.ceil(value * (1 / this.incrementLength)) * this.incrementLength;
        var hiddenInput =  wrapper.find('.product-measurement-selector__hidden');
        hiddenInput.val(roundedValue / this.incrementLength);
        
        if (parseFloat(hiddenInput.attr('max')) < parseFloat(hiddenInput.val())) {
            hiddenInput.val(hiddenInput.attr('max'));
            hiddenInput.trigger('change');
            wrapper.find('.product-measurement-selector__input').val(hiddenInput.val()*this.incrementLength);
            return hiddenInput.val()*this.incrementLength;
        }

        hiddenInput.trigger('change');
        wrapper.find('.product-measurement-selector__input').val(roundedValue);
        return roundedValue;
    },
  
    quantityControl: function() {
      var self = this;
      jQuery(document).on('change', '.product-measurement-selector__input', function(){
        var wrapper = jQuery(this).parents(".product-measurement-selector__wrapper");
        var value = parseFloat($(this).val());
        var minLength = self.minLength(jQuery(this));
        value = isNaN(value)?minLength:value;
        if(value < minLength) {
            value = minLength;
        }
        self.updateQuantity(value, wrapper);
        managePrice.updatePrice();
      });
    },
  
    quantityIncrease: function() {
      var self = this;
      jQuery(document).on('click', '.product-measurement-selector__incr', function(){
        var wrapper = jQuery(this).parents(".product-measurement-selector__wrapper");
        var inputField = $(this).siblings('input[type="number"]');
        var hiddenInput =  wrapper.find('.product-measurement-selector__hidden');

        if(parseFloat(hiddenInput.attr('max')) == hiddenInput.val()){
            return;
        }

        var currentValue = parseFloat(inputField.val());
        var newValue = currentValue + self.incrementLength;
        self.updateQuantity(newValue, wrapper);
        managePrice.updatePrice();
      });
    },

    quantityDecrease: function() {
        var self = this;
        jQuery(document).on('click', '.product-measurement-selector__decr', function(){
          var wrapper = jQuery(this).parents(".product-measurement-selector__wrapper");
          var inputField = $(this).siblings('input[type="number"]');
          var currentValue = parseFloat(inputField.val());
          var newValue = currentValue - self.incrementLength;
          var minLength = self.minLength(inputField);
          if(newValue < minLength){
            return;
          }

          self.updateQuantity(newValue, wrapper);
          managePrice.updatePrice();
        });
    },

    updateVariant: function(selectedVariant) {
      let hiddenInput = jQuery('form[action="/cart/add"] .product-measurement-selector__hidden');

      if(selectedVariant.inventory_management == 'shopify') {
        hiddenInput.attr('max', selectedVariant.inventory_quantity);
      } else {
        hiddenInput.removeAttr('max');
      }
    },

    setVariantUpdateEvent: async function() {
      await new Promise(
        (resolve) => {
          let intervalId = setInterval(
            () => {
              if(typeof BoosterTheme == 'undefined') {
                return;
              }

              clearInterval(intervalId);
              resolve();
            }
          );
        }
      );

      if(typeof BoosterTheme.swatches == 'undefined') {
        return;
      }

      BoosterTheme.swatches.THEME_UTILS.events.on(
        'booster:variant:select',
        (arguments) => {
          this.updateVariant(arguments.selectedVariant);
        }
      );
    },

    minLength: function(inputField) {
      return parseFloat(inputField.attr('min'));
    }

  };
  
  jQuery(document).ready(function() {
    productMeasurementSelector.init();
  });
  